import React, {Component} from 'react';
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Nav,
  NavLink,
  NavDropdown,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Collapse,
} from 'reactstrap';
import {Link, withRouter} from 'react-router-dom';

import './AppNavbar.scss';
import auth from '../lib/auth';

class AppNavbar extends Component {

  constructor(props) {
    super(props);

    this.doLogout = this.doLogout.bind(this);
    this.state = {
      user: {},
    };
  }

  async componentDidMount() {
    this.setState({
      user: await auth.user(),
    });
  }

  doLogout() {
    auth.logout();
    this.props.history.push('/');
    window.location.reload();

  }

  render() {
    this.user = this.state.user;
    return (
        <Navbar light color="white"
                className="header BlockAppNavbar d-flex align-items-center"
                expand="md">
          <div className="container">
            <NavbarBrand>
              <img src={process.env.PUBLIC_URL + '/img/logo.svg'}
                   alt={process.env.REACT_APP_NAME}/>
            </NavbarBrand>
            <NavbarToggler onClick={this.toggle}/>
            <Collapse navbar>
              <Nav className="ml-auto" navbar>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret className="callus">
                    <img src={this.user.picture}
                         className="user-profile--avatar" height={48}
                         width={48}/>
                  </DropdownToggle>
                  <DropdownMenu right>
                    <div
                        className="row user-profile no-gutters d-flex align-items-center">
                      <div className="col-md-4">
                        <img src={this.user.picture}
                             className="user-profile--avatar" height={48}
                             width={48}/>
                      </div>
                      <div className="col-md-8">
                        <div
                            className="user-profile--name">{(this.user.nickname ? this.user.nickname +
                            ' ' + this.user.family_name : null) || this.user.name ||
                        this.user.email}</div>
                        {this.user.profile ?
                            (<div
                                className="user-profile--position">{this.user.profile}</div>) :
                            null}
                      </div>
                    </div>
                    <DropdownItem to="/profile/edit" tag={Link}>
                      Edit Profile
                    </DropdownItem>
                    {
                      this.user.isAdmin ? [
                        <DropdownItem divider key="divider"/>,
                        <DropdownItem to="/admin/users" tag={Link}
                                      key="users_link">
                          Manage Users
                        </DropdownItem>,
                        <DropdownItem to="/admin/groups" tag={Link}
                                      key="groups_link">
                          Manage Groups
                        </DropdownItem>,
                        <DropdownItem to="/admin/faq" tag={Link}
                                      key="faq_link">
                          Manage FAQs
                        </DropdownItem>,
                      ] : null
                    }
                    <DropdownItem divider/>
                    <DropdownItem onClick={this.doLogout}>
                      Logout
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Collapse>

          </div>
        </Navbar>
    );
  }

}

export default withRouter(AppNavbar);


// WEBPACK FOOTER //
// ./src/blocks/AppNavbar.js